import { SVGProps, Ref, forwardRef } from 'react';

export const VkSquareBrandSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M1 11.56c0-4.978 0-7.467 1.546-9.014S6.582 1 11.56 1h.88c4.978 0 7.467 0 9.013 1.546S23 6.582 23 11.56v.88c0 4.978 0 7.467-1.547 9.013S17.418 23 12.44 23h-.88c-4.978 0-7.467 0-9.014-1.547S1 17.418 1 12.44z"
                fill="#0077FF"
            />
            <path
                d="M12.706 16.85c-5.014 0-7.874-3.438-7.994-9.158h2.512c.083 4.198 1.934 5.976 3.4 6.343V7.692h2.366v3.62c1.448-.155 2.97-1.805 3.483-3.62h2.365c-.394 2.236-2.044 3.886-3.217 4.565 1.173.55 3.052 1.989 3.767 4.592h-2.603c-.56-1.742-1.953-3.089-3.795-3.272v3.272z"
                fill="white"
            />
        </g>
    </svg>
));
VkSquareBrandSize24Glyph.displayName = 'VkSquareBrandSize24Glyph';
